import { render, staticRenderFns } from "./LocationForItemBaseData.vue?vue&type=template&id=20981f56&scoped=true"
import script from "./LocationForItemBaseData.vue?vue&type=script&lang=js"
export * from "./LocationForItemBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20981f56",
  null
  
)

export default component.exports